import React from 'react'
import ReactDOM from 'react-dom/client'

import { HistoryDetail } from '../pages/history'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <HistoryDetail />
    </React.StrictMode>
  )
}
